import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stripe-guide',
  templateUrl: './stripe-guide.component.html',
  styleUrls: ['./stripe-guide.component.scss']
})
export class StripeGuideComponent implements OnInit {

  constructor() { }


  ngOnInit() {
    const loader = document.getElementById("reg-loader");
    if (loader) {
      loader.remove();
    }
  }

  load(id: string) {
    document.getElementById(id).scrollIntoView();
  }
}




// WEBPACK FOOTER //
// ./src/app/stripe-guide/stripe-guide.component.ts